import React from 'react';

type Language = 'en' | 'ro';

interface LanguageTabsProps {
  currentLang: Language;
  onChange: (lang: Language) => void;
}

export const LanguageTabs: React.FC<LanguageTabsProps> = ({ currentLang, onChange }) => {
  return (
    <div className="admin-lang-tabs">
      <button
        type="button"
        className={`admin-lang-tab ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => onChange('en')}
      >
        🇬🇧 English
      </button>
      <button
        type="button"
        className={`admin-lang-tab ${currentLang === 'ro' ? 'active' : ''}`}
        onClick={() => onChange('ro')}
      >
        🇷🇴 Romanian
      </button>
    </div>
  );
};

export default LanguageTabs;
